﻿// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', p: '25px 0px 0px 0px', mt: 'auto' }}>
      <Typography variant="caption">
        <Link href="https://syn.digital/" target="_blank" underline="hover">
        &copy; {year} Syn {' '}
        </Link>
         All rights reserved
      </Typography>
      <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
        <Link href="https://syn.digital/who-are-we/" target="_blank" variant="caption" color="text.primary">
          About us
        </Link>
        <Link href="https://syn.digital/privacy-policy/" target="_blank" variant="caption" color="text.primary">
          Privacy
        </Link>
        <Link href="https://syn.digital/terms-conditions/" target="_blank" variant="caption" color="text.primary">
          Terms
        </Link>
      </Stack>
    </Stack>
  );
}

